import React from 'react';
import cx from './cx';

const AppSelect = ({ className = '', size, children, ...rest }) => (
  <select
    className={cx('form-select', size === 'sm' && 'form-select-sm', className)}
    {...rest}
  >
    {children}
  </select>
);

export default AppSelect;
